import script from "./Calculator.vue?vue&type=script&setup=true&lang=js"
export * from "./Calculator.vue?vue&type=script&setup=true&lang=js"

import "./Calculator.vue?vue&type=style&index=0&id=ccfa36da&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tax-calculator/tax-calculator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccfa36da"]])

export default __exports__